import { useSyncExternalStore } from 'react';

const KEY = 'hub.course.v1';
const subs = new Set<() => void>();

function read(): string {
  try {
    return localStorage.getItem(KEY) ?? 'calc1';
  } catch {
    return 'calc1';
  }
}

let current = typeof window === 'undefined' ? 'calc1' : read();

function subscribe(cb: () => void) {
  subs.add(cb);
  return () => subs.delete(cb);
}

export function useCurrentCourse(): [string, (id: string) => void] {
  const id = useSyncExternalStore(subscribe, () => current);
  return [
    id,
    (next: string) => {
      current = next;
      try {
        localStorage.setItem(KEY, next);
      } catch {
        /* ignore */
      }
      subs.forEach(f => f());
    }
  ];
}
